/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var FolderCheckIcon24Solid = forwardRef('FolderCheckIcon24Solid', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 24 }, props),
        React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M2 5a2 2 0 0 1 2-2h4.868a2 2 0 0 1 1.715.971l.399.665a.75.75 0 0 0 .643.364H18a4 4 0 0 1 4 4v8a4 4 0 0 1-4 4H6a4 4 0 0 1-4-4V5Zm15.468 5.669a1 1 0 0 0-1.414-1.414l-5.175 5.175a.5.5 0 0 1-.707 0l-1.964-1.964a1 1 0 0 0-1.414 1.414l1.963 1.964a2.5 2.5 0 0 0 3.536 0l5.175-5.175Z" })));
});
